import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { optimizeLabelStack, stringifyLabelStackFully } from '../common/utils';
export function optimizeHoldInfo(holdInfo, interactionStart, reactUFOVersion) {
  var holdInfoMap = holdInfo.reduce(function (result, hold) {
    var labelStack = hold.labelStack,
      name = hold.name,
      start = hold.start,
      end = hold.end,
      ignoreOnSubmit = hold.ignoreOnSubmit;
    if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
      var label = stringifyLabelStackFully([].concat(_toConsumableArray(labelStack), [{
        name: name
      }]));
      var startTime = Math.round(start);
      var endTime = Math.round(end);
      var timing = result.get(label) || {
        labelStack: optimizeLabelStack([].concat(_toConsumableArray(labelStack), [{
          name: name
        }]), reactUFOVersion),
        startTime: startTime,
        endTime: endTime
      };
      if (startTime < timing.startTime) {
        timing.startTime = startTime;
      }
      if (endTime > timing.endTime) {
        timing.endTime = endTime;
      }
      result.set(label, timing);
    }
    return result;
  }, new Map());
  return _toConsumableArray(holdInfoMap.values());
}